"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGBlackDodgeSidewaysGenerator = exports.CTGBlackDodgeGenerator = exports.CTGComboCardMoveGenerator = exports.CTGRedPickupGenerator = exports.CTGICardMoveGenerator = exports.CTGFlappyFriendGenerator = exports.CTGFlappyGenerator = exports.CTGDodgeGeneratorDodgablesOnly = exports.CTGDodgeGeneratorTrenchRun = exports.CTGNormalHighestGenerator = exports.CTGNormalLowestGenerator = exports.CTGNormalGeneratorOneCard = exports.CTGNormalDifferenceGenerator = exports.CTGDifferenceType = exports.CTGNormalColorGenerator = exports.CTGNormalSuitGenerator = exports.CTGIStandardGenerator = exports.CTGRandom4x4PokerFlushGenerator = exports.CTGRandom4x4PokerStraightGenerator = exports.CTGRandom4x4PokerFourOfAKindGenerator = exports.CTGRandom4x4BlackjackGenerator = exports.CTGRandom4x413Generator = exports.CTGRandom4x4MatchGenerator = exports.CTGRandom4x4AscendingGenerator = exports.CTGRandom4x4DeckGeneratorAscending = exports.CTGRandom4x4DeckGenerator = exports.CTGRandom4x4Generator = exports.CTGI4x4Generator = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const KHHelperFunctions_1 = require("../KH/KHHelperFunctions");
class CTGI4x4Generator {
    getCards(rand, percent, min_cards, max_count) {
        return this.getCardsInternal(rand, Math.floor(Math.min(max_count, (max_count - min_cards) * percent + min_cards)), max_count);
    }
    total_count(initial, percent, max_count) {
        return Math.floor(Math.min(max_count, (max_count - initial) * percent + initial));
    }
    fill_remainder(rand, cards, target) {
        for (let i = cards.length; i < target; i++) {
            cards.push(CTGCard_1.CTGCard.randomCard(rand));
        }
        return cards;
    }
    fill_remainder_from_deck(rand, deck, cards, target) {
        rand.shuffleArray(deck);
        cards.push(...deck.slice(0, target - cards.length));
        return cards;
    }
    cards_to_highlight() {
        return [];
    }
}
exports.CTGI4x4Generator = CTGI4x4Generator;
class CTGRandom4x4Generator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        const cards = [];
        this.fill_remainder(rand, cards, target);
        return cards;
    }
}
exports.CTGRandom4x4Generator = CTGRandom4x4Generator;
class CTGRandom4x4DeckGenerator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        let deck = CTGCard_1.CTGCard.deck();
        rand.shuffleArray(deck);
        return deck.slice(0, target);
    }
}
exports.CTGRandom4x4DeckGenerator = CTGRandom4x4DeckGenerator;
class CTGRandom4x4DeckGeneratorAscending extends CTGRandom4x4DeckGenerator {
    getCardsInternal(rand, target, cap) {
        let deck = CTGCard_1.CTGCard.deck();
        rand.shuffleArray(deck);
        deck.sort((a, b) => a.rank - b.rank);
        return deck.slice(0, target).reverse();
    }
}
exports.CTGRandom4x4DeckGeneratorAscending = CTGRandom4x4DeckGeneratorAscending;
class CTGRandom4x4AscendingGenerator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        let start = CTGCard_1.CTGRank.Ace;
        if (target < 13)
            start = 14 - target;
        const cards = [];
        for (let i = 0; i < target; i++) {
            cards.push(CTGCard_1.CTGCard.randomFixedCard(rand, undefined, undefined, Math.min(CTGCard_1.CTGRank.King, start + i)));
        }
        return cards;
    }
}
exports.CTGRandom4x4AscendingGenerator = CTGRandom4x4AscendingGenerator;
class CTGRandom4x4MatchGenerator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        const cards = [];
        if (target % 1 == 1)
            target--;
        for (let i = 0; i < target / 2; i++) {
            const suit = rand.getRandomEnum(CTGCard_1.CTGSuit);
            const rank = rand.getRandomEnum(CTGCard_1.CTGRank);
            cards.push(new CTGCard_1.CTGCard(suit, rank));
            cards.push(new CTGCard_1.CTGCard(suit, rank));
        }
        rand.shuffleArray(cards);
        return cards;
    }
}
exports.CTGRandom4x4MatchGenerator = CTGRandom4x4MatchGenerator;
class CTGRandom4x413Generator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        const cards = [];
        if (target % 1 == 1)
            target--;
        for (let i = 0; i < target / 2; i++) {
            const suit = rand.getRandomEnum(CTGCard_1.CTGSuit);
            const rank = rand.getRandomEnum(CTGCard_1.CTGRank);
            const other_rank = rank == CTGCard_1.CTGRank.King ? CTGCard_1.CTGRank.King : (CTGCard_1.CTGRank.King - rank);
            cards.push(new CTGCard_1.CTGCard(suit, rank));
            cards.push(new CTGCard_1.CTGCard(suit, other_rank));
        }
        rand.shuffleArray(cards);
        return cards;
    }
}
exports.CTGRandom4x413Generator = CTGRandom4x413Generator;
class CTGRandom4x4BlackjackGenerator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        const cards = [];
        let running_total = 0;
        while (running_total < 11) {
            let card = CTGCard_1.CTGCard.randomCardWithBlackjackValue(rand, rand.nextInt(1, 11));
            cards.push(card);
            running_total += card.blackjackMinValue();
            // Sometimes make the ace worth 10 and sometimes 1.
            if (card.rank == CTGCard_1.CTGRank.Ace) {
                running_total += rand.nextBoolean() ? 10 : 0;
            }
        }
        if (running_total > 10) {
            cards.push(CTGCard_1.CTGCard.randomCardWithBlackjackValue(rand, 21 - running_total));
        }
        this._cards_to_highlight = [...cards];
        let remainder = Math.max(1, target - cards.length);
        for (let i = 0; i < remainder; i++) {
            cards.push(CTGCard_1.CTGCard.randomCardWithBlackjackValue(rand, rand.nextInt(2, 10)));
        }
        rand.shuffleArray(cards);
        return cards;
    }
    cards_to_highlight() {
        return this._cards_to_highlight;
    }
}
exports.CTGRandom4x4BlackjackGenerator = CTGRandom4x4BlackjackGenerator;
class CTGRandom4x4PokerFourOfAKindGenerator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        const cards = [];
        let running_total = 0;
        let deck = CTGCard_1.CTGCard.deck();
        const rank = rand.getRandomEnum(CTGCard_1.CTGRank);
        cards.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Clubs, rank));
        cards.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Hearts, rank));
        cards.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Diamonds, rank));
        cards.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Spades, rank));
        this._cards_to_highlight = [...cards];
        deck = deck.filter(x => x.rank != rank);
        this.fill_remainder_from_deck(rand, deck, cards, target);
        rand.shuffleArray(cards);
        return cards;
    }
    cards_to_highlight() {
        return this._cards_to_highlight;
    }
}
exports.CTGRandom4x4PokerFourOfAKindGenerator = CTGRandom4x4PokerFourOfAKindGenerator;
class CTGRandom4x4PokerStraightGenerator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        const cards = [];
        let deck = CTGCard_1.CTGCard.deck();
        rand.shuffleArray(deck);
        // Straight can start with A-10.
        let rank = rand.nextInt(1, 11);
        let previous = rank - 1;
        deck = deck.filter(x => x.rank != previous);
        for (let i = 0; i < 5; i++) {
            let card = CTGCard_1.CTGCard.randomFixedCard(rand, undefined, undefined, rank);
            cards.push(card);
            deck = deck.filter(x => !x.equals(card));
            rank++;
            if (rank == 14)
                rank = 1;
        }
        this._cards_to_highlight = [...cards];
        deck = deck.filter(x => x.rank != rank);
        this.fill_remainder_from_deck(rand, deck, cards, target);
        rand.shuffleArray(cards);
        return cards;
    }
    cards_to_highlight() {
        return this._cards_to_highlight;
    }
}
exports.CTGRandom4x4PokerStraightGenerator = CTGRandom4x4PokerStraightGenerator;
class CTGRandom4x4PokerFlushGenerator extends CTGI4x4Generator {
    getCardsInternal(rand, target, cap) {
        let deck = CTGCard_1.CTGCard.deck();
        rand.shuffleArray(deck);
        // Straight can start with A-10.
        let suit = rand.getRandomEnum(CTGCard_1.CTGSuit);
        let cards = deck.filter(x => x.suit == suit).slice(0, 5);
        this._cards_to_highlight = [...cards];
        deck = deck.filter(x => x.suit != suit);
        this.fill_remainder_from_deck(rand, deck, cards, target);
        rand.shuffleArray(cards);
        return cards;
    }
    cards_to_highlight() {
        return this._cards_to_highlight;
    }
}
exports.CTGRandom4x4PokerFlushGenerator = CTGRandom4x4PokerFlushGenerator;
class CTGIStandardGenerator {
    start(rand, total_rows) { }
}
exports.CTGIStandardGenerator = CTGIStandardGenerator;
function subset_to_select(rand, total, num) {
    let nums = [];
    for (let i = 0; i < total; i++) {
        nums.push(i);
    }
    return rand.getNRandom(nums, num);
}
class CTGNormalSuitGenerator extends CTGIStandardGenerator {
    constructor(color_in_row, suit) {
        super();
        this.color_in_row = color_in_row;
        this.suit = suit;
    }
    getRow(rand, numberOfCards) {
        let num_cards = this.color_in_row;
        if (num_cards <= 0) {
            num_cards = rand.nextInt(0, numberOfCards + 1);
        }
        let differentIdxs = subset_to_select(rand, numberOfCards, num_cards);
        let other_suits = rand.arrayFromEnum(CTGCard_1.CTGSuit).filter(x => x != this.suit);
        let cards = [];
        for (let i = 0; i < numberOfCards; i++) {
            if (differentIdxs.includes(i)) {
                const card = CTGCard_1.CTGCard.randomFixedCard(rand, undefined, this.suit);
                card.tap_requirement = CTGCard_1.CTGTapRequirement.Must;
                cards.push(card);
            }
            else {
                const card = CTGCard_1.CTGCard.randomFixedCard(rand, undefined, rand.getRandom(other_suits));
                card.tap_requirement = CTGCard_1.CTGTapRequirement.Dont;
                cards.push(card);
            }
        }
        return cards;
    }
}
exports.CTGNormalSuitGenerator = CTGNormalSuitGenerator;
class CTGNormalColorGenerator extends CTGIStandardGenerator {
    constructor(color_in_row) {
        super();
        this.color_in_row = color_in_row;
    }
    getRow(rand, numberOfCards) {
        let num_cards = this.color_in_row;
        if (num_cards <= 0) {
            num_cards = rand.nextInt(0, numberOfCards + 1);
        }
        let differentIdxs = subset_to_select(rand, numberOfCards, num_cards);
        let cards = [];
        for (let i = 0; i < numberOfCards; i++) {
            if (differentIdxs.includes(i)) {
                const card = CTGCard_1.CTGCard.randomFixedCard(rand, CTGCard_1.CTGColor.Red);
                card.tap_requirement = CTGCard_1.CTGTapRequirement.Must;
                cards.push(card);
            }
            else {
                const card = CTGCard_1.CTGCard.randomFixedCard(rand, CTGCard_1.CTGColor.Black);
                card.tap_requirement = CTGCard_1.CTGTapRequirement.Dont;
                cards.push(card);
            }
        }
        return cards;
    }
}
exports.CTGNormalColorGenerator = CTGNormalColorGenerator;
var CTGDifferenceType;
(function (CTGDifferenceType) {
    CTGDifferenceType[CTGDifferenceType["Suit"] = 0] = "Suit";
    CTGDifferenceType[CTGDifferenceType["Color"] = 1] = "Color";
    CTGDifferenceType[CTGDifferenceType["Rank"] = 2] = "Rank";
    CTGDifferenceType[CTGDifferenceType["SuitHard"] = 3] = "SuitHard";
    CTGDifferenceType[CTGDifferenceType["Any"] = 4] = "Any";
})(CTGDifferenceType = exports.CTGDifferenceType || (exports.CTGDifferenceType = {}));
class CTGNormalDifferenceGenerator extends CTGIStandardGenerator {
    constructor(diffType) {
        super();
        this.differenceType = diffType;
    }
    getRow(rand, numberOfCards) {
        let changeType = this.differenceType;
        let differentIdx = rand.nextInt(0, numberOfCards);
        if (this.differenceType == CTGDifferenceType.Any) {
            changeType = rand.getRandom([CTGDifferenceType.Color, CTGDifferenceType.Rank, CTGDifferenceType.Suit]);
        }
        let cards = [];
        let fixedRank = rand.getRandomEnum(CTGCard_1.CTGRank);
        let fixedSuit = rand.getRandomEnum(CTGCard_1.CTGSuit);
        switch (changeType) {
            case CTGDifferenceType.Color:
                let colors = rand.arrayFromEnum(CTGCard_1.CTGColor);
                rand.shuffleArray(colors);
                let suit1 = CTGCard_1.CTGCard.randomSuit(rand, colors[0]);
                let suit2 = CTGCard_1.CTGCard.randomSuit(rand, colors[1]);
                for (let i = 0; i < numberOfCards; i++) {
                    cards.push(CTGCard_1.CTGCard.randomFixedCard(rand, undefined, i == differentIdx ? suit1 : suit2, fixedRank));
                }
                break;
            case CTGDifferenceType.Rank:
                let ranks = rand.getNRandomEnum(CTGCard_1.CTGRank, 2);
                for (let i = 0; i < numberOfCards; i++) {
                    cards.push(CTGCard_1.CTGCard.randomFixedCard(rand, undefined, fixedSuit, i == differentIdx ? ranks[0] : ranks[1]));
                }
                break;
            case CTGDifferenceType.Suit:
            default:
                let suits = rand.getNRandomEnum(CTGCard_1.CTGSuit, 2);
                for (let i = 0; i < numberOfCards; i++) {
                    cards.push(CTGCard_1.CTGCard.randomFixedCard(rand, undefined, i == differentIdx ? suits[0] : suits[1], fixedRank));
                }
                break;
            case CTGDifferenceType.SuitHard:
                let suit = rand.getRandomEnum(CTGCard_1.CTGSuit);
                let other = CTGCard_1.CTGSuit.Diamonds;
                switch (suit) {
                    case CTGCard_1.CTGSuit.Clubs:
                        other = CTGCard_1.CTGSuit.Spades;
                        break;
                    case CTGCard_1.CTGSuit.Spades:
                        other = CTGCard_1.CTGSuit.Clubs;
                        break;
                    case CTGCard_1.CTGSuit.Diamonds:
                        other = CTGCard_1.CTGSuit.Hearts;
                        break;
                    case CTGCard_1.CTGSuit.Hearts:
                        other = CTGCard_1.CTGSuit.Diamonds;
                        break;
                }
                for (let i = 0; i < numberOfCards; i++) {
                    cards.push(CTGCard_1.CTGCard.randomFixedCard(rand, undefined, i == differentIdx ? suit : other, fixedRank));
                }
                break;
        }
        for (let i = 0; i < numberOfCards; i++) {
            cards[i].tap_requirement = i == differentIdx ? CTGCard_1.CTGTapRequirement.Must : CTGCard_1.CTGTapRequirement.Dont;
        }
        return cards;
    }
}
exports.CTGNormalDifferenceGenerator = CTGNormalDifferenceGenerator;
class CTGNormalGeneratorOneCard extends CTGIStandardGenerator {
    start(rand, total_rows) {
        super.start(rand, total_rows);
        this._row_with_card = Math.floor(rand.nextInt(5, total_rows - 5));
        this._row_idx = 0;
    }
    getRow(rand, numberOfCards) {
        let differentIdxs = subset_to_select(rand, numberOfCards, this._row_idx == this._row_with_card ? 1 : 0);
        this._row_idx++;
        let cards = [];
        for (let i = 0; i < numberOfCards; i++) {
            if (differentIdxs.includes(i)) {
                const card = CTGCard_1.CTGCard.randomFixedCard(rand, CTGCard_1.CTGColor.Red);
                card.tap_requirement = CTGCard_1.CTGTapRequirement.Must;
                cards.push(card);
            }
            else {
                const card = CTGCard_1.CTGCard.randomFixedCard(rand, CTGCard_1.CTGColor.Black);
                card.tap_requirement = CTGCard_1.CTGTapRequirement.Dont;
                cards.push(card);
            }
        }
        return cards;
    }
}
exports.CTGNormalGeneratorOneCard = CTGNormalGeneratorOneCard;
class CTGNormalLowestGenerator extends CTGIStandardGenerator {
    getRow(rand, numberOfCards) {
        let differentIdx = rand.nextInt(0, numberOfCards);
        let ranks = KHHelperFunctions_1.arrayFromEnum(CTGCard_1.CTGRank);
        let minIdx = rand.nextInt(0, ranks.length - 1);
        let cards = [];
        for (let i = 0; i < numberOfCards; i++) {
            cards.push(CTGCard_1.CTGCard.randomFixedCard(rand, undefined, undefined, differentIdx == i ? ranks[minIdx] : ranks[rand.nextInt(minIdx + 1, ranks.length)]));
            cards[i].tap_requirement = i == differentIdx ? CTGCard_1.CTGTapRequirement.Must : CTGCard_1.CTGTapRequirement.Dont;
        }
        return cards;
    }
}
exports.CTGNormalLowestGenerator = CTGNormalLowestGenerator;
class CTGNormalHighestGenerator extends CTGIStandardGenerator {
    getRow(rand, numberOfCards) {
        let differentIdx = rand.nextInt(0, numberOfCards);
        let ranks = KHHelperFunctions_1.arrayFromEnum(CTGCard_1.CTGRank);
        let maxIdx = rand.nextInt(1, ranks.length);
        let cards = [];
        for (let i = 0; i < numberOfCards; i++) {
            cards.push(CTGCard_1.CTGCard.randomFixedCard(rand, undefined, undefined, differentIdx == i ? ranks[maxIdx] : ranks[rand.nextInt(0, maxIdx)]));
            cards[i].tap_requirement = i == differentIdx ? CTGCard_1.CTGTapRequirement.Must : CTGCard_1.CTGTapRequirement.Dont;
        }
        return cards;
    }
}
exports.CTGNormalHighestGenerator = CTGNormalHighestGenerator;
class CTGIRowAwareGenerator extends CTGIStandardGenerator {
    constructor(history) {
        super();
    }
    start(rand, total_rows) {
        this.historical_rows = [];
    }
    getRow(rand, numberOfCards) {
        let row = this.getRowWithHistory(rand, numberOfCards, this.historical_rows);
        this.historical_rows.shift();
        this.historical_rows.push(row);
        return row;
    }
}
class CTGDodgeGeneratorTrenchRun extends CTGIRowAwareGenerator {
    constructor(extra_width, turn_chance, collectable_chance) {
        super(1);
        this.extra_width = extra_width;
        this.turn_chance = turn_chance;
        this.collectable_chance = collectable_chance;
    }
    start(rand, total_rows) {
        super.start(rand, total_rows);
        this.right = rand.nextBoolean();
        this.idx = this.right ? 0 - this.extra_width : 3;
    }
    getRowWithHistory(rand, numberOfCards, history) {
        let just_turned = false;
        if (this.idx + this.extra_width < 0) {
            this.idx = 1 - this.extra_width;
            this.right = true;
            just_turned = true;
        }
        if (this.idx >= numberOfCards) {
            this.idx = numberOfCards - 2;
            this.right = false;
            just_turned = true;
        }
        let row = [];
        for (let i = 0; i < numberOfCards; i++) {
            if (i >= this.idx && i <= this.idx + this.extra_width) {
                if (rand.withChance(this.collectable_chance)) {
                    row.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Hearts, CTGCard_1.CTGRank.Jack, CTGCard_1.CTGTapRequirement.Must));
                }
                else {
                    row.push(null);
                }
            }
            else {
                row.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Clubs, CTGCard_1.CTGRank.King, CTGCard_1.CTGTapRequirement.Dont));
            }
        }
        if (!just_turned && rand.withChance(this.turn_chance)) {
            this.right = !this.right;
        }
        this.idx = this.idx + (this.right ? 1 : -1);
        return row;
    }
}
exports.CTGDodgeGeneratorTrenchRun = CTGDodgeGeneratorTrenchRun;
class CTGDodgeGeneratorDodgablesOnly extends CTGIRowAwareGenerator {
    constructor() {
        super(1);
    }
    getRowWithHistory(rand, numberOfCards, history) {
        if (history.length < 1) {
            return this.randomWithLength(rand, numberOfCards - 2, numberOfCards);
        }
        let last_row = history[this.historical_rows.length - 1];
        let row = [];
        for (let i = 0; i < numberOfCards; i++) {
            if (last_row[i] != null) {
                row.push(rand.nextBoolean() ? new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Spades, CTGCard_1.CTGRank.Ace, CTGCard_1.CTGTapRequirement.Dont) : null);
            }
            else {
                let last_null = i;
                for (let j = i + 1; j < numberOfCards; j++) {
                    if (last_row[j] == null)
                        last_null = j;
                    else
                        break;
                }
                if (last_null == i) {
                    row.push(null);
                }
                else {
                    row.push(...this.randomWithLength(rand, (last_null - i), last_null - i + 1));
                }
                i = last_null;
            }
        }
        return row;
    }
    randomWithLength(rand, min, length) {
        if (min < 0)
            min = 0;
        let max_cards = rand.nextInt(min, length);
        let valid_idxs = [];
        for (let i = 0; i < length; i++) {
            valid_idxs.push(i);
        }
        rand.shuffleArray(valid_idxs);
        valid_idxs = valid_idxs.slice(0, max_cards);
        let row = [];
        for (let i = 0; i < length; i++) {
            row.push(valid_idxs.includes(i) ? new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Spades, CTGCard_1.CTGRank.Ace, CTGCard_1.CTGTapRequirement.Dont) : null);
        }
        return row;
    }
}
exports.CTGDodgeGeneratorDodgablesOnly = CTGDodgeGeneratorDodgablesOnly;
class CTGFlappyGenerator extends CTGIStandardGenerator {
    constructor(gap_between_columns) {
        super();
        this.last_gap = -100;
        this.curr_idx = 0;
        this.gap_between_columns = gap_between_columns;
    }
    start(rand, total_rows) {
        super.start(rand, total_rows);
        this.last_gap = -100;
        this.curr_idx = 0;
    }
    getRow(rand, numberOfCards) {
        let gap = rand.nextInt(2, numberOfCards - 1);
        let gap_radius = 3;
        this.curr_idx++;
        const row = [];
        if (this.curr_idx - this.last_gap >= this.gap_between_columns) {
            for (let i = 0; i < numberOfCards; i++) {
                if (i < gap - gap_radius || i > gap + gap_radius) {
                    row.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Spades, CTGCard_1.CTGRank.Eight, CTGCard_1.CTGTapRequirement.Dont));
                }
                else {
                    row.push(null);
                }
            }
            this.last_gap = this.curr_idx;
        }
        else {
            for (let i = 0; i < numberOfCards; i++) {
                row.push(null);
            }
        }
        return row;
    }
}
exports.CTGFlappyGenerator = CTGFlappyGenerator;
class CTGFlappyFriendGenerator extends CTGIStandardGenerator {
    constructor(gap_between_columns) {
        super();
        this.last_gap = -100;
        this.curr_idx = 0;
        this.gap_between_columns = gap_between_columns;
    }
    start(rand, total_rows) {
        super.start(rand, total_rows);
        this.last_gap = -100;
        this.curr_idx = 0;
    }
    getRow(rand, numberOfCards) {
        let gap = rand.nextInt(0, numberOfCards - 2);
        let gap_radius = 3;
        this.curr_idx++;
        const row = [];
        if (this.curr_idx - this.last_gap >= this.gap_between_columns) {
            for (let i = 0; i < numberOfCards; i++) {
                if (i == gap) {
                    const card = new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Hearts, CTGCard_1.CTGRank.Five, CTGCard_1.CTGTapRequirement.Must);
                    card.rot = 90;
                    row.push(card);
                }
                else {
                    row.push(null);
                }
            }
            this.last_gap = this.curr_idx;
        }
        else {
            for (let i = 0; i < numberOfCards; i++) {
                row.push(null);
            }
        }
        return row;
    }
}
exports.CTGFlappyFriendGenerator = CTGFlappyFriendGenerator;
class CTGICardMoveGenerator {
}
exports.CTGICardMoveGenerator = CTGICardMoveGenerator;
class CTGRedPickupGenerator extends CTGICardMoveGenerator {
    get_initial_cards(rand, difficulty) {
        return [this.make_card(rand, [])];
    }
    card_destroyed(rand, difficulty, cards) {
        return [this.make_card(rand, cards)];
    }
    update(rand, difficulty, now, delta) {
        return null;
    }
    make_card(rand, cards) {
        let card = CTGCard_1.CTGCard.randomFixedCard(rand, CTGCard_1.CTGColor.Red);
        card.tap_requirement = CTGCard_1.CTGTapRequirement.Must;
        let min_dist = 10;
        let min_dist_2 = min_dist * min_dist;
        let min_dist_red = 20;
        let min_dist_red_2 = min_dist_red * min_dist_red;
        let reroll = true;
        const max_attempts = 100;
        for (let i = 0; i < max_attempts && reroll; i++) {
            card.x = rand.nextInt(8, 64 - 12);
            card.y = rand.nextInt(8, 64 - 7);
            reroll = false;
            for (const other of cards) {
                if (Phaser.Math.Distance.Squared(card.x, card.y, other.x, other.y)
                    < (other.color() == CTGCard_1.CTGColor.Red ? min_dist_red_2 : min_dist_2)) {
                    reroll = true;
                    break;
                }
            }
            if (reroll && i == max_attempts - 1) {
                console.log("Too many attempts");
            }
        }
        return card;
    }
}
exports.CTGRedPickupGenerator = CTGRedPickupGenerator;
class CTGComboCardMoveGenerator extends CTGICardMoveGenerator {
    constructor(generators) {
        super();
        this.generators = generators;
    }
    get_initial_cards(rand, difficulty) {
        let new_cards = [];
        this.generators.forEach((generator) => {
            const adds = generator.get_initial_cards(rand, difficulty);
            if (adds != null)
                new_cards.push(...adds);
        });
        return new_cards;
    }
    card_destroyed(rand, difficulty, cards) {
        let new_cards = [];
        this.generators.forEach((generator) => {
            const adds = generator.card_destroyed(rand, difficulty, cards);
            if (adds != null)
                new_cards.push(...adds);
        });
        return new_cards;
    }
    update(rand, difficulty, now, delta) {
        let new_cards = [];
        this.generators.forEach((generator) => {
            const adds = generator.update(rand, difficulty, now, delta);
            if (adds != null)
                new_cards.push(...adds);
        });
        return new_cards;
    }
}
exports.CTGComboCardMoveGenerator = CTGComboCardMoveGenerator;
class CTGBlackDodgeGenerator extends CTGICardMoveGenerator {
    constructor(number_of_cards) {
        super();
        this.number_of_cards = number_of_cards;
    }
    get_initial_cards(rand, difficulty) {
        let cards = [];
        for (let i = 0; i < this.number_of_cards; i++) {
            let card = this.make_card(rand, cards);
            cards.push(card);
        }
        return cards;
    }
    card_destroyed(rand, difficulty, cards) {
        return null;
    }
    update(rand, difficulty, now, delta) {
        return null;
    }
    make_card(rand, cards) {
        let card = CTGCard_1.CTGCard.randomFixedCard(rand, CTGCard_1.CTGColor.Black);
        card.tap_requirement = CTGCard_1.CTGTapRequirement.Dont;
        let min_dist = 15;
        let min_dist_2 = min_dist * min_dist;
        let reroll = true;
        for (let i = 0; i < 10 && reroll; i++) {
            card.x = rand.nextInt(8, 64 - 12);
            card.y = 15;
            reroll = false;
            for (const other of cards) {
                if (Phaser.Math.Distance.Squared(card.x, card.y, other.x, other.y) < min_dist_2) {
                    reroll = true;
                    break;
                }
            }
        }
        return card;
    }
}
exports.CTGBlackDodgeGenerator = CTGBlackDodgeGenerator;
const bounds = [[7, 10], [52, 55]];
class CTGBlackDodgeSidewaysGenerator extends CTGICardMoveGenerator {
    constructor(number_of_cards) {
        super();
        this.number_of_cards = number_of_cards;
    }
    get_initial_cards(rand, difficulty) {
        let cards = [];
        for (let i = 0; i < this.number_of_cards; i++) {
            let card = this.make_card(rand, cards, i);
            cards.push(card);
        }
        return cards;
    }
    card_destroyed(rand, difficulty, cards) {
        return null;
    }
    update(rand, difficulty, now, delta) {
        return null;
    }
    make_card(rand, cards, idx) {
        let card = CTGCard_1.CTGCard.randomFixedCard(rand, CTGCard_1.CTGColor.Black);
        card.tap_requirement = CTGCard_1.CTGTapRequirement.Dont;
        let min_dist = 15;
        let min_dist_2 = min_dist * min_dist;
        let reroll = true;
        for (let i = 0; i < 10 && reroll; i++) {
            card.x = idx % 2 == 1 ? bounds[0][0] : bounds[1][0];
            card.y = 62 - (3 - idx) * 15 - 7;
            ;
            reroll = false;
            for (const other of cards) {
                if (Phaser.Math.Distance.Squared(card.x, card.y, other.x, other.y) < min_dist_2) {
                    reroll = true;
                    break;
                }
            }
        }
        return card;
    }
}
exports.CTGBlackDodgeSidewaysGenerator = CTGBlackDodgeSidewaysGenerator;
